module.exports = __webpack_public_path__ + "static/media/login-button.0c51cd30.png";